import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconMail: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fill={fill}
        d="M3.33317 1.33337H16.6665C17.5832 1.33337 18.3332 2.08337 18.3332 3.00004V13C18.3332 13.9167 17.5832 14.6667 16.6665 14.6667H3.33317C2.4165 14.6667 1.6665 13.9167 1.6665 13V3.00004C1.6665 2.08337 2.4165 1.33337 3.33317 1.33337Z"
        stroke="#CACCCF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default IconMail;
